/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
import AddableEmail from 'material/addableemaillist/addableemail/addableemail';
import Icon from 'material/graphic/icon/icon';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
import Link from 'material/ctas/link/link_container';
import {validation} from 'utils/validation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/addableemaillist/addableemaillist_styles';



/* ========== ~~~~~~~~~~ REPORTS : ADDABLEEMAIL : CHILD ~~~~~~~~~~ ========== */
// NOTE
// The email array should have 'value' and 'valid' keys. This is needed for form validation.
// COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AddableEmailList extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.usersPermitted && this.props.allUsers.length < 1) this.props.getUsers(this.props.accountUUID);
    }

    checkIfValid = (email) => (
        validation.email.test.test(email)
    )

    editEmail = (item, index) => (
        this.props.editEmail({value: item, index, valid: this.checkIfValid(item)})
    )

    getAddableEmail = (email, valid, index) => (
        <div className={`addable-email-div`}>
            <AddableEmail value={email} valid={valid} required={true} allUsers={this.props.allUsers} handleSelect={(email) => {this.editEmail(email, index)}} handleBlur={(email) => {this.editEmail(email, index)}}/>
            { this.props.emails.length > 1 && <Link type={`custom`} text={``} handleClick={(e) => this.removeEmail(index)} icon={<Icon name={`times-circle`} klass={`remove`} />} iconRight /> }
        </div>
    );

    addEmail = (value) => {
        value = value.length > 0 ? value : "";
        this.props.addEmail(value);
    };

    removeEmail = (index) => (
        this.props.removeEmail(index)
    );

    getAddNewAddableEmailLink = () => (
        <Link type={`custom`} text={`Add a new address`} color={`primary`} handleClick={this.addEmail} icon={<Icon name={`plus-circle`} />} iconRight />
    );

    getEmailList = () => (
        <GridSet direction={`vertical`}>
            {this.props.emails.map((email, index) => (
                    <GridItem key={`${index}`}>
                        {this.getAddableEmail(email.value, email.valid, index)}
                    </GridItem>
                ))
            }
        </GridSet>
    );

    render() {
        return (
            <div className={`addableemaillist ${this.props.classes.addableemaillist}`}>
                {this.props.emails.length > 0 ? this.getEmailList() : this.addEmail(this.props.userEmail)}
                {this.getAddNewAddableEmailLink()}
            </div>
        );
    }

};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddableEmailList);